import CustomAttrConst from '../constants/customAttributes.constants';

export const customAddCategory = item => ({
  type: CustomAttrConst.CUSTOM_CATEGORY_ADD,
  value: item,
});

export const customUpdateCategory = (tempid, item) => ({
  type: CustomAttrConst.CUSTOM_CATEGORY_UPDATE,
  tempid,
  value: item,
});

export const customDeleteCategory = (id, del_type) => ({
  type: CustomAttrConst.CUSTOM_CATEGORY_DELETE,
  id,
  del_type,
});

export const customAddAttributes = (cat_id, item) => ({
  type: CustomAttrConst.CUSTOM_ATTRIBUTES_ADD,
  value: item,
  cat_id,

});


export const customEditAttributes = (id, cat_id, item, oldCatId) => ({
  type: CustomAttrConst.CUSTOM_ATTRIBUTES_EDIT,
  cat_id,
  items: item,
  id,
  oldCatId,
});

export const customDeleteAttributes = (id, del_type, cat_id) => ({
  type: CustomAttrConst.CUSTOM_ATTRIBUTES_DELETE,
  id,
  del_type,
  cat_id,
});


export const customCategoryEdit = (id, name, description) => ({
  type: CustomAttrConst.CUSTOM_CATEGORY_EDIT,
  id,
  name,
  description,
});

export const orgEngUpdate = item => ({
  type: CustomAttrConst.ORG_ENG_UPDATE,
  value: item,
});
